/**
 * sessionId — 탭 범위 익명 세션 식별자.
 *
 * 개인식별 정보(IP·UA)를 수집하지 않는다. 탭마다 1회 생성하고
 * sessionStorage 에 보관해 탭을 닫으면 자동 소멸한다.
 * 서버 쿠키·로그인 세션과 무관하다.
 */

const SESSION_STORAGE_KEY = 'fo_session_id';

/**
 * 인메모리 폴백 — sessionStorage·crypto 미지원 환경에서 사용.
 * 모듈이 로드되는 시점(탭 생존기간)동안만 유효하다.
 */
let inMemoryId: string | null = null;

/** UUID v4 생성. crypto.randomUUID 미지원 시 Math.random 기반 폴백 */
function generateUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // 구형 환경 폴백 — 충돌 확률이 미미한 수준
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * 탭 범위 익명 세션 ID 반환.
 * 같은 탭 내에서는 항상 동일한 값을 반환한다.
 * sessionStorage 미지원 환경에서는 인메모리 값으로 대체한다.
 */
export function getSessionId(): string {
  // 1차: sessionStorage 조회
  try {
    const stored = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (stored) return stored;

    const id = generateUuid();
    sessionStorage.setItem(SESSION_STORAGE_KEY, id);
    return id;
  } catch {
    // sessionStorage 접근 불가(iframe sandbox, 개인정보 보호 모드 등)
  }

  // 2차: 인메모리 폴백
  if (!inMemoryId) {
    inMemoryId = generateUuid();
  }
  return inMemoryId;
}
